import { ref } from 'vue-demi';
import { useMutationObserver } from '@vueuse/core';

import { IAgentMultiUser } from '@/types';
import { getColorType } from '@/common';

export const getAgentMultiUserName = (user: IAgentMultiUser) => {
  return user?.data?.profile?.firstName && user.data.profile.lastName
    ? `${user.data.profile.firstName} ${user.data.profile.lastName}`
    : '';
};

/** Mutation observer is probably very efficient and we can use it in multiple places */
export const useTrackBGColor = () => {
  const bgColorType = ref('' as 'light' | 'dark');

  const trackBGColor = (args: { ref: HTMLElement; }) => {
    bgColorType.value = getColorType(getComputedStyle(args.ref).backgroundColor);

    useMutationObserver(args.ref, () => {
      const property = getComputedStyle(args.ref).backgroundColor;
      bgColorType.value = getColorType(property);
    }, {
      attributes: true,
      attributeFilter: ['style', 'class'],
    });
  };

  return { bgColorType, trackBGColor };
};
